import { Link } from 'react-router-dom';
import { type Project } from '../services/projects';
import { trackEvent } from '../firebase';

interface Props {
  project: Project;
}

export default function ProjectCard({ project }: Props) {
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm hover:shadow-md transition-shadow flex flex-col gap-2">
      <Link
        to={`/projects/${project.id}`}
        className="text-base font-bold text-gray-900 hover:text-brand-500 transition-colors"
        onClick={() => trackEvent('view_project', { project_id: project.id })}
      >
        {project.name}
      </Link>
      {project.description && <p className="text-sm text-gray-500 m-0">{project.description}</p>}
      <div className="flex items-center gap-3 mt-1">
        <span className="inline-flex items-center bg-violet-100 text-violet-700 text-xs font-semibold px-2 py-0.5 rounded-full">
          {project.subscriberCount} subscribers
        </span>
        {project.createdAt && (
          <span className="text-xs text-gray-400">
            Created {project.createdAt.toLocaleDateString()}
          </span>
        )}
      </div>
      <div className="flex gap-2 mt-2">
        <Link
          to={`/projects/${project.id}`}
          className="flex-1 inline-flex items-center justify-center px-3 py-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded-md text-sm font-semibold transition-colors"
          onClick={() => trackEvent('view_project', { project_id: project.id })}
        >
          View
        </Link>
      </div>
    </div>
  );
}
